import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Container,
  Grid,
  CardMedia,
  IconButton,
  Box,
  Checkbox,
  Breadcrumbs,
  Link,
} from "@mui/material";
import male from "../../assets/salon_male.png";
import female from "../../assets/salon_female.png";
import {
  FavoriteBorder,
  AppRegistration as AppRegistrationIcon,
  Share as ShareIcon,
  WhatsApp as WhatsAppIcon,
  LocalOffer as LocalOfferIcon,
  Info as InfoIcon,
  PlayArrow as PlayArrowIcon,
  Call as CallIcon,
  Directions as DirectionsIcon,
  Favorite,
} from "@mui/icons-material";
import HomeIcon from "@mui/icons-material/Home";
import { information } from "../../constants/locationData";

import { api } from "../../utils/api";
import axios from "../../utils/axios";
import CardLanding from "../../common/landingPage/card";
import { useSelector } from "react-redux";
import { getAlldetailSerice, getAllServices } from "./servicesListApi";
import MediaModel from "../../common/mediaModel";
import { routePath } from "../../constants/routePath";
import { useNavigate } from "react-router";
import ApModal from "../../common/AppoinmetModalppBtn";
import { getSession, setSession } from "../../utils/commonUtils";
import FavoritePage from "../landingPage/FavouritePage";
import SEO from "../../common/SEO";

const FavRate = () => {
  return (
    // <Box sx={{ py: 5, backgroundColor: "#bb4a9b26" }}>
    //   <Container>
    //     <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
    //       <Box
    //         sx={{
    //           cursor: "pointer",
    //           backgroundColor: "#ffffffb3",
    //           borderRadius: "20px",
    //           px: "15px",
    //         }}
    //         onClick={() => navigate(routePath.LANDINGPAGE)}
    //       >
    //         Home
    //       </Box>
    //       <Typography
    //         color="secondary"
    //         sx={{
    //           backgroundColor: "#ffffffb3",
    //           borderRadius: "20px",
    //           px: "15px",
    //         }}
    //       >
    //         Services
    //       </Typography>
    //     </Breadcrumbs>
    //     <MediaModel open={open} setOpen={setOpen} modelData={modelData} />

    //     <Grid container spacing={3}>
    //       {serViceList.map((item, index) => (
    //         <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
    //           {/* <CardLanding
    //             item={item}
    //             openModel={setHide}
    //             addFav={() => {
    //               console.log("favprod card cb");

    //               favCard(item);
    //             }}
    //             remove={() => {
    //               delfavCard(item);
    //             }}
    //             callback={() => {
    //               setOpen(true);
    //               setModelData({ ...item });
    //               console.log("data click");
    //             }}
    //           /> */}
    //         </Grid>
    //       ))}
    //     </Grid>
    //   </Container>
    //   <ApModal open={hide} setOpen={setHide} />
    // </Box>

    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/fav"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <FavoritePage />
    </>
  );
};

export default FavRate;
